import { FieldExtraOption, FormatedField } from "../types/fields.types";

export const getFieldExtraOption = (extraOptions: FieldExtraOption[], field: FormatedField) => {
    if (!extraOptions) return null;

    return extraOptions?.filter((fieldExtraOption: FieldExtraOption) => {
        return fieldExtraOption.field === field.field;
    })[0];
};
